import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { AuthStore, readTabToken } from '../core/auth/auth-store';
import {
  persistInitialSearchParams,
  restoreInitialSearchParams,
} from '../core/initial-search-params';

const INITIAL_TOKEN_SESSION_KEY = 'nr:initial-token';

export const tokenResolver: ResolveFn<string> = async (route) => {
  const authStore = inject(AuthStore);
  const urlToken = typeof route.params['token'] === 'string' ? route.params['token'] : '';
  const storedInitialToken = sessionStorage.getItem(INITIAL_TOKEN_SESSION_KEY);

  if (urlToken && urlToken !== storedInitialToken) {
    sessionStorage.setItem(INITIAL_TOKEN_SESSION_KEY, urlToken);
    persistInitialSearchParams();
    authStore.token.set(urlToken);
    return urlToken;
  }

  restoreInitialSearchParams();
  // A reload: the URL token was rotated on open, so use the one this tab is reading with. The
  // shared cookie is only a fallback for tabs opened before the tab token existed.
  const token = readTabToken() ?? (await cookieStore.get('token'))?.value ?? urlToken;
  authStore.token.set(token);
  return token;
};
